(function () {
    'use strict';

    function SalesCountController($uibModal, $scope, $state, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, ReportService) {
        var $ctrl = this;
        $ctrl.labels = [];
        $ctrl.series = ['تعداد'];
        $ctrl.data = [
            // [42, 17, 28, 73, 50, 12, 68]
        ];

        $ctrl.weekStartDate = '';
        $ctrl.weekEndDate = '';
        $ctrl.lastWeekReserveNumber = 0;
        $ctrl.lastMonthReserveNumber = 0;

        var s1 = [];
        $ctrl.chartData = ReportService.getSalesCountReportOfCurrentCompany().get(function (chartData) {

            if (chartData)

                var item = [];

            angular.forEach(chartData.data, function (item) {
                $ctrl.lastMonthReserveNumber += +item.value;

                $ctrl.labels.push(item.label);
                s1.push(item.value);
            })

            for (var i = 25; i <= 31; i++) {
                if (chartData.data[i]) {
                    item = chartData.data[i];
                    // $ctrl.labels.push(item.label);
                    // s1.push(item.value);

                    $ctrl.lastWeekReserveNumber += +item.value;

                }
            }


            if (chartData.data[31]) {


                $ctrl.weekStartDate = chartData.data[25].label;
                $ctrl.weekEndDate = chartData.data[31].label;
            } else {


                $ctrl.weekStartDate = chartData.data[24].label;
                $ctrl.weekEndDate = chartData.data[chartData.data.length - 1].label;
            }


            $scope.$emit('weekInfo', $ctrl.lastWeekReserveNumber, $ctrl.lastMonthReserveNumber, $ctrl.weekStartDate, $ctrl.weekEndDate); // going up to parent!

            $ctrl.data.push(s1);

        });

        $ctrl.onClick = function (points, evt) {
            //console.log(points, evt);
        };
        $ctrl.datasetOverride = [{yAxisID: 'y-axis-1'}, {yAxisID: 'y-axis-2'}];
        $ctrl.options = {
            title: {
                display: true,
                text: 'نمودار فعالیت یک ماه گذشته'
            },
            scales: {
                yAxes: [

                    {
                        id: 'y-axis-1',
                        type: 'linear',
                        display: true,
                        position: 'left',

                        ticks: {
                            beginAtZero: true,
                            userCallback: function (label, index, labels) {
                                // when the floored value is the same as the value we have a whole number
                                if (Math.floor(label) === label) {
                                    return label;
                                }

                            },
                        }
                    }
                ]
            }
        };

    };
    var SalesCountComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/dashboard/sales_report/report.sales_count.template.html',
        controller: SalesCountController,
        bindings:
            {
                date: '=?',
            }

    };
    angular
        .module('tikonApp')
        .component('rpSalesCount', SalesCountComponent);

    SalesCountController.$inject = ['$uibModal', '$scope', '$state', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'ReportService'];


})();

